/**
 * VENDOR INVOICES MODULE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getBills, getBill, printBill, createBills, updateBills, deleteBills } from "Modules/supply_chain/bills/config/api.bills";

const state = {
    page: {},
    form: {},
    bills: [],
    selectedBill: {
        bill_id: null,
        company_id: "",
        vendor_invoice_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        bill_details: [],
    },
    bills_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_bills: {
        bill_id: {
            name: "bill_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_order_id: {
            name: "purchase_order_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        invoice_number: {
            name: "invoice_number",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        invoice_date: {
            name: "invoice_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        due_date: {
            name: "due_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate_id: {
            name: "exchange_rate_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "18",
            min_len: "",
            default_value: "1.000000",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "20",
        },
        work_order_no: {
            name: "work_order_no",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        subtotal: {
            name: "subtotal",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount_type: {
            name: "discount_type",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        freight: {
            name: "freight",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customs: {
            name: "customs",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        expedite_fee: {
            name: "expedite_fee",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        handling_charge: {
            name: "handling_charge",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        total_amount: {
            name: "total_amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_details: {
            bill_detail_id: {
                name: "bill_detail_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            bill_id: {
                name: "bill_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            map_id: {
                name: "map_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            price: {
                name: "price",
                rules: "trim|max_length[13]|decimal",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            line_discount_amount: {
                name: "line_discount_amount",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_percentage: {
                name: "line_discount_percentage",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_type: {
                name: "line_discount_type",
                rules: "trim|max_length[1]",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            line_total: {
                name: "line_total",
                rules: "trim|max_length[13]|decimal|required",
                max_len: "12",
                min_len: "",
                default_value: "0.000",
            },
        },
    },
};

// getters
const getters = {
    bills: (state) => {
        return state.bills;
    },
};

// actions
const actions = {
    async fetchBills({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getBills({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageBills", response.data.page);
                }

                commit("setBills", response.data.bills);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchBill({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getBill(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedBill", response.data.bill);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printBill({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printBill(payload.id, payload.view_as);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveBill({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["bill_id"] === "undefined" || body["bill_id"] == null || body["bill_id"] == "") {
                delete body["bill_id"];
                response = await createBills({ body: body, headers: config.headers });
            } else {
                let bill_id = body["bill_id"];
                delete body["bill_id"];
                response = await updateBills({ body: body, headers: config.headers }, bill_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteBill({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteBills(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageBills(state, page) {
        state.page = page;
    },
    setBills(state, bills) {
        state.bills = bills;
    },
    setSelectedBill(state, bill) {
        state.selectedBill = bill;
    },
    resetSelectedBill(state) {
        for (const key in state.selectedBill) {
            if (key in state.rules_bills) {
                state.selectedBill[key] = state.rules_bills[key].default_value == "null" ? null : state.rules_bills[key].default_value;
            }
        }
    },
    resetBills(state) {
        state.page = {};
        state.form = {};
        state.bills = [];
        state.selectedBill = {
            bill_id: null,
            company_id: "",
            vendor_invoice_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            bill_details: [],
        };
        state.bills_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
